import { type IntlShape } from 'react-intl'

import { type PublicGlobalConfig } from '../global-config'
import {
  urlResolverGetAccountOrders,
  urlResolverGetOffersCategoryPage,
} from '../url-handling'

export const contactPageAccessorGetOrderSectionData = (
  config: {
    globalConfig: PublicGlobalConfig
    intl: IntlShape
    isUserLoggedIn: boolean
  },
  totalOrderItems?: number,
): { ctaId: string; ctaLabel: string; description: string; href?: string } => {
  const { globalConfig, intl, isUserLoggedIn } = config
  const viewAllOrdersLabel = intl.formatMessage({
    id: 'contact.ordersSection.cta.label',
  })

  const logInLabel = intl.formatMessage({ id: 'general.label.subscribe' })
  const findProductsLabel = intl.formatMessage({
    id: 'contact.ordersSection.cta.findProductsLabel',
  })

  const descriptionLabel = intl.formatMessage({
    id: 'helpCenter.ordersSection.description.v1',
  })

  if (!isUserLoggedIn) {
    return {
      ctaId: 'orders-section-cta-login',
      ctaLabel: logInLabel,
      description: descriptionLabel,
      href: undefined,
    }
  }

  if (totalOrderItems === 0) {
    return {
      ctaId: 'orders-section-cta-offers',
      ctaLabel: findProductsLabel,
      description: descriptionLabel,
      href: urlResolverGetOffersCategoryPage(globalConfig),
    }
  }

  return {
    ctaId: 'orders-section-cta-orders',
    ctaLabel: viewAllOrdersLabel,
    description: descriptionLabel,
    href: urlResolverGetAccountOrders(globalConfig),
  }
}
